import { useParams } from 'react-router';
import { getErrorData } from './helpers';
import { Page, Flex, Box, Header, Message } from 'components';
import './style.scss';

function PageError() {
  const { code: paramErrorCode } = useParams();
  const errorData = getErrorData(paramErrorCode);

  return (
    <Page title={errorData.pageTitle}>
      <Flex
        alignItems='center'
        direction='column'
      >
        <div className='error-page-filler-Vmluq' />
        <Box
          padding={20}
          className='error-cntr-xKkv'
        >
          <Flex
            direction='column'
            gap={20}
          >
            <Header align='center'>Ошибка! Что-то пошло не так!</Header>

            <div className='error-code-Yb2G'>{errorData.title}</div>
            <Message
              type='info'
              className='error-message-QmDT'
            >
              {errorData.description}
            </Message>
            <Flex
              direction='column'
              gap={10}
            >
              {errorData.buttons}
            </Flex>
          </Flex>
        </Box>
      </Flex>
    </Page>
  );
}

export default PageError;
